import { VerbFetch } from '../VerbFetch';

export const postSegmentEvent = (params) => {
    const { body, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/segmentevent`;
    const options = {
        method: 'POST',
        body
    };
    return VerbFetch(baseUrl, options);
};
